/**
 * Content Fitness framework version. Stored on every subcriterion assessment
 * and rollup so historic reports stay explainable after the taxonomy changes.
 * The value is intentionally versioned data; the code identifiers around it
 * are not.
 */
export const CONTENT_FITNESS_FRAMEWORK_VERSION = "content-fitness.v1.2";
